/**
 * 存储localStorage
 */
export var setLocalStorage = function (name, content) {
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    try {
        localStorage.setItem(name, content);
    }
    catch (error) {
        console.error(error);
    }
};
/**
 * 获取localStorage
 */
export var getLocalStorage = function (name) {
    try {
        var res = localStorage.getItem(name);
        if (res) {
            return JSON.parse(res);
        }
    }
    catch (error) {
        console.error(error);
    }
};
/**
 * 删除localStorage
 */
export var removeLocalStorage = function (name) {
    try {
        localStorage.removeItem(name);
    }
    catch (error) {
        console.error(error);
    }
};
